/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-12-01 13:52:54
 * @LastEditors: Andy
 * @LastEditTime: 2023-01-17 16:50:29
 */
const routes = [
  {
    path: '/403',
    name: '403',
    meta: {
      noAuth: true
    },
    component: () => import('@main/modules/errorPage/views/403.vue')
  },
  {
    path: '/404',
    name: '404',
    meta: {
      noAuth: true
    },
    component: () => import('@main/modules/errorPage/views/404.vue')
  }
]
export default routes
